import { format } from 'date-fns/format'
import { isValid } from 'date-fns/isValid'
import { enGB } from 'date-fns/locale/en-GB'
import { parseISO } from 'date-fns/parseISO'
import { subDays } from 'date-fns/subDays'

export function getCanteenRatingPeriod(now = new Date()) {
  return {
    periodStart: subDays(now, 7).toISOString(),
    periodEnd: subDays(now, 1).toISOString(),
  }
}

export function formatRatingWeekday(value: string | null | undefined): string {
  const date = value === undefined ? new Date() : value === null ? new Date(NaN) : parseISO(value)
  return isValid(date) ? format(date, 'EEEE', { locale: enGB }) : 'Invalid date'
}
